const commonStyle = {
    contentRight: {
        textAlign: "right"
    },
    floatLeft: {float: "left"},
    floatRight: {float: "right"}
}
export default commonStyle;